// extracted by mini-css-extract-plugin
export default {"root":"PayoutWaitlistNotice_root__fi9fk","title":"PayoutWaitlistNotice_title__xbW6K"};